module.exports = __webpack_public_path__ + "static/sonoma_garden_grill-d01176f085f301e5b0c3794ce653631a.jpg";